import type { CardPointeTerminalSaleResponseDetails } from './cardpointe-terminal-sale-response.types';
import type {
    CardPointeTerminalSaleLegacyRequestDetails,
    CardPointeTerminalSaleRequestDetails,
} from './cardpointe-terminal-sale.types';

export const CardPointeTerminalSaleLifecyclePayloadType = {
    REQUEST_V1: 'cardpointe_terminal_sale_request_v1',
    REQUEST_V2: 'cardpointe_terminal_sale_request_v2',
    RESPONSE: 'cardpointe_terminal_sale_response_v1',
} as const;

export type CardPointeTerminalSaleLifecyclePayloadType =
    (typeof CardPointeTerminalSaleLifecyclePayloadType)[keyof typeof CardPointeTerminalSaleLifecyclePayloadType];

export interface CardPointeTerminalSaleRequestLifecyclePayloadV1 {
    readonly gateway_lifecycle_payload_type: typeof CardPointeTerminalSaleLifecyclePayloadType.REQUEST_V1;
    readonly request_details: CardPointeTerminalSaleRequestDetails;
}

export interface CardPointeTerminalSaleLegacyRequestLifecyclePayload {
    readonly gateway_lifecycle_payload_type: typeof CardPointeTerminalSaleLifecyclePayloadType.REQUEST_V1;
    readonly request_details: CardPointeTerminalSaleLegacyRequestDetails;
}

export type StoredCardPointeTerminalSaleRequestLifecyclePayloadV1 =
    | CardPointeTerminalSaleRequestLifecyclePayloadV1
    | CardPointeTerminalSaleLegacyRequestLifecyclePayload;

export interface CardPointeTerminalSaleRequestLifecyclePayloadV2 {
    readonly gateway_lifecycle_payload_type: typeof CardPointeTerminalSaleLifecyclePayloadType.REQUEST_V2;
    readonly request_details: CardPointeTerminalSaleRequestDetails;
}

export interface CardPointeTerminalSaleResponseLifecyclePayload {
    readonly gateway_lifecycle_payload_type: typeof CardPointeTerminalSaleLifecyclePayloadType.RESPONSE;
    readonly response_details: CardPointeTerminalSaleResponseDetails;
}

export type CardPointeTerminalSaleLifecyclePayload =
    | CardPointeTerminalSaleRequestLifecyclePayloadV2
    | CardPointeTerminalSaleResponseLifecyclePayload;
